import React from 'react';
import Grid from '@material-ui/core/Grid';

import { PAGE_COPYRIGHT } from '../../constants';
import CustomGridContainer from '../custom/gridcontainer';
import CustomLink from '../custom/link';
import CustomTypography from '../custom/typography';
import useStyles from './styles';

export default function Copyright() {
  const classes = useStyles();
  return (
    <CustomGridContainer>
      <Grid item>
        <CustomTypography>
          {PAGE_COPYRIGHT.DEVELOPMENT_BY}
        </CustomTypography>
      </Grid>
      <Grid item>
        <CustomTypography>
          &nbsp;
          <CustomLink href={PAGE_COPYRIGHT.LINK}>{PAGE_COPYRIGHT.LINK_TEXT}</CustomLink>
          &nbsp;
        </CustomTypography>
      </Grid>
      <Grid item>
        <img className={classes.logo} src={PAGE_COPYRIGHT.LOGO} alt={PAGE_COPYRIGHT.LOGO_ALT}/>
      </Grid>
      <Grid item>
        <CustomTypography>
          &nbsp;
          {new Date().getFullYear()}
          .
        </CustomTypography>
      </Grid>
    </CustomGridContainer>
  );
}
